import script from "./IbhFastbookingContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./IbhFastbookingContainer.vue?vue&type=script&setup=true&lang=js"

import "./IbhFastbookingContainer.vue?vue&type=style&index=0&id=6409eb5d&lang=scss"

const __exports__ = script;

export default __exports__